import { browser } from "$app/environment"
import { isDeploymentEnv } from "$lib/environment"
import Castle from "@castleio/castle-js"
import { TwSession, type TwRestSession } from "@tastyworks/tastyworks-api"

const TW_SESSION_ID_KEY = "tw-session-id"
const TW_EMAIL_KEY = "tw-email"
const TW_NEW_USER_KEY = "tw-new-user"

class Session extends TwSession implements TwRestSession {
  private readonly castle = this.initializeCastleIo()

  constructor() {
    super("AO2")
  }

  get currentEmail() {
    return sessionStorage.getItem(TW_EMAIL_KEY) as string
  }

  set currentEmail(email) {
    sessionStorage.setItem(TW_EMAIL_KEY, email)
  }

  get sessionToken() {
    return sessionStorage.getItem(TW_SESSION_ID_KEY) as string
  }

  set sessionToken(token) {
    sessionStorage.setItem(TW_SESSION_ID_KEY, token)
  }

  get isNewUser() {
    return JSON.parse(sessionStorage.getItem(TW_NEW_USER_KEY) || "false")
  }

  set isNewUser(isNewUser: boolean) {
    sessionStorage.setItem(TW_NEW_USER_KEY, `${isNewUser}`)
  }

  clear() {
    sessionStorage.removeItem(TW_SESSION_ID_KEY)
    sessionStorage.removeItem(TW_EMAIL_KEY)
  }

  override async createCastleIoRequestToken() {
    return this.castle?.createRequestToken() ?? ""
  }

  private initializeCastleIo() {
    // prevent castle from running on the server or non deployed environments
    if (!isDeploymentEnv() || !browser) return null

    return Castle.configure({
      pk: import.meta.env.VITE_CASTLE_PUBLISHABLE_API_KEY,
    })
  }
}

const session = new Session()

export default session
